import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import { LazyImg } from '@ifeng/ui_pc_lazyLoad';
import styles from './index.css';
import { rel } from '../../../../../../../utils/rel';

const NewBox = errorBoundary(
    class extends PureComponent {
        static propTypes = {
            content: PropTypes.object,
        };

        render() {
            const {
                content: { first, left },
            } = this.props;

            const rightLiList = left
                ? left.map((item, index) => (
                      <li key={index}>
                          <a href={item.url} target="_blank" rel={rel}>
                              {item.title}
                          </a>
                      </li>
                  ))
                : null;

            return first ? (
                <div className={styles.box_list}>
                    <div className={styles.box_list_pic}>
                        <a href={first.url} target="_blank" rel={rel}>
                            <LazyImg src={first.thumbnail} width="170" height="100" />
                        </a>
                    </div>
                    <div className={styles.box_list_word}>
                        <h2>
                            <a href={first.url} target="_blank" rel={rel}>
                                {first.title}
                            </a>
                        </h2>
                        <ul>{rightLiList}</ul>
                    </div>
                </div>
            ) : null;
        }
    },
);

export { NewBox };
export default NewBox;
